<ng-container *transloco="let t">
  <a
    [routerLink]="urlFragments"
    [queryParams]="queryParameters"
    class="product-model-item"
    [class.mobile]="(biggerThan$ | async)?.xs"
    [class.widescreen]="(biggerThan$ | async)?.sm"
    [class.collection-item]="collectionItem">
    <span class="pic-wrapper flex">
      <app-picture class="picture" [alt]="product" [pictureUrl]="imageUrl"></app-picture>
    </span>
    <span class="fixed-space-8" aria-hidden="true"></span>
    <span class="head-wrapper text-gray-05">
      <span class="discount flex flex-col justify-center align-center">
        <h4 class="model flex justify-center ltr">{{ parsedModel }}</h4>
        @if (storage && color) {
          <span class="flex">
            <span>{{ (storage || '') + 'GB' }}</span>
            <span class="fixed-space-4" aria-hidden="true"></span>
            <span aria-hidden="true" class="fixed-space-8"></span>
            <span class="icon-wrap">|</span>
            <span aria-hidden="true" class="fixed-space-8"></span>
            <span>{{ t(getTransLabel(color || '')) || '' }}</span>
          </span>
        }
        <span class="fixed-space-8" aria-hidden="true"></span>
        <span class="text-center"
          >{{ t('label_starting_at') }}
          <span class="text-highlight margin-0 bold">{{ price | amount }}</span>
          <span
            class="nowrap"
            [innerHTML]="
              t('price_banner_highlight_or', { var1: price | installmentAmount })
            "></span
        ></span>
      </span>
    </span>
  </a>
</ng-container>
